import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="min-h-screen bg-[#F5FBF9]">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <div className="lg:ml-[280px] min-h-screen">
        {/* Mobile Header */}
        <header className="lg:hidden sticky top-0 z-20 bg-white border-b border-slate-100 px-4 py-3">
          <button
            onClick={toggleSidebar}
            className="p-2 hover:bg-slate-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3BA99C]"
            data-testid="mobile-menu-btn"
            aria-label="Apri menu di navigazione"
            aria-expanded={sidebarOpen}
          >
            <Menu className="w-6 h-6 text-slate-600" aria-hidden="true" />
          </button>
        </header>

        {/* Page Content */}
        <main id="main-content" className="p-4 sm:p-6 lg:p-8" tabIndex="-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;